(function () {
    const initializeImageSlider = () => {
        // Query elements directly without jQuery overhead to fit standalone custom assets
        document.querySelectorAll(".js-get-section").forEach(function (parent) {
            const sliderContainer = parent.querySelector(`.js-swiper-image-slider`);

            if (!sliderContainer) return;

            // Safe reset instance check to ensure proper lifecycle operations inside the Theme Editor
            if (sliderContainer.swiper) {
                sliderContainer.swiper.destroy(true, true);
            }

            const paginationDots = parent.querySelector(`.js-image-slider-pagination`);
            const prevArrow = parent.querySelector(`.js-image-slider-prev`);
            const nextArrow = parent.querySelector(`.js-image-slider-next`);

            // Initialize standard single slide instance structure
            new Swiper(sliderContainer, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                grabCursor: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: paginationDots,
                    clickable: true,
                },
                navigation: {
                    prevEl: prevArrow,
                    nextEl: nextArrow,
                }
            });
        });
    };

    // Binding block logic to match browser DOM and Theme customizer cycles securely
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initializeImageSlider);
    } else {
        initializeImageSlider();
    }

    document.addEventListener("shopify:section:load", function (event) {
        initializeImageSlider();
    });
})();